import React, { useState, useEffect, useCallback } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import parse from 'date-fns/parse';
import de from 'date-fns/locale/de';
import { startOfDay } from '../../utils/Dates';
import './styles/react-datepicker.css';
import DatePickerContainer from './DatePickerContainer';

registerLocale('de', de);

const baseDate = startOfDay(new Date());

function isValidDate(str: string, format: string) {
    if (!str) return false;
    const date = parse(str, format, baseDate);
    if (!date) return false;

    return date.getTime() > 0;
}


interface DatePickerProps {
    id?: string
    placeholderText: string
    dateFormat: string
    initialDate?: Date
    disabled?: boolean
    customInput?: React.ReactNode
    onChange: (date: Date) => void
}

const DatePicker: React.FC<DatePickerProps> = ({ id, placeholderText, dateFormat, initialDate, disabled, customInput, onChange }) => {
    const [value, setValue] = useState<Date | undefined>(initialDate);
    const onChangeHandler = useCallback((date, event: React.SyntheticEvent<any> | undefined) => {
        // console.log('onChangeHandler', date);
        const fixedDate = startOfDay(date)
        setValue(fixedDate);
        onChange?.(fixedDate);
    }, [onChange]);
    useEffect(() => setValue(initialDate), [initialDate]);
    return (
        <ReactDatePicker
            id={id}
            placeholderText={placeholderText}
            showWeekNumbers
            locale="de"
            dateFormat={dateFormat}
            // openToDate={openToDate}
            customInput={customInput}
            selected={value}
            disabled={disabled}
            // calendarContainer={DateTimePickerContainer}
            calendarContainer={({ children }) => {
                return (
                    <DatePickerContainer title={Intl.DateTimeFormat().resolvedOptions().timeZone}>
                        {children}
                    </DatePickerContainer>
                )
            }}
            onChange={onChangeHandler}
            onChangeRaw={(event) => {
                const raw = event.target.value;
                // console.log('onChangeRaw', hidePopper, strictParsing, raw, event);
                if (!isValidDate(raw, dateFormat)) {
                    // console.log('onChangeRaw invalid value', raw);
                    setValue(undefined);
                    // if (onChange) onChange(undefined);
                }
            }}
        />
    );
};

export default DatePicker;
